// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"home-module--imgContainer--7OK4e","imgText":"home-module--imgText--3eScj","subtitles":"home-module--subtitles--1juIX"};